import React from "react";
import { SUBSCRIPTIONS_ICONS_MAP } from "./VehicleManagementConstants";
import "./SubscriptionIcons.css";

/**
 * Renders subscription icons for a vehicle or bundle row.
 *
 * @param {Object} props
 * @param {string[]} props.subscriptions - Array of subscription names (e.g. "Vehicle Tracking", "AI Dash Cam").
 * @param {React.ReactNode} [props.fallback] - What to render when there are no subscriptions. Defaults to null.
 * @param {string} [props.className] - Optional extra class name(s) on the outer wrapper.
 */
const SubscriptionIcons = ({ subscriptions = [], fallback = null, className = "" }) => {
  if (!subscriptions || subscriptions.length === 0) return fallback;

  const validSubscriptions = subscriptions.filter(Boolean);
  if (validSubscriptions.length === 0) return fallback;

  return (
    <span className={`subscriptionIconsWrap ${className}`.trim()}>
      {validSubscriptions.map((sub, index) => (
        <div key={index} className="subscriptionIconBox" title={sub}>
          <img src={SUBSCRIPTIONS_ICONS_MAP[sub]} alt={`${sub}-icon`} width={12} height={12} />
        </div>
      ))}
    </span>
  );
};

export default SubscriptionIcons;
